export const blockIconsHomeMfgNestYaleLockNew = (
	<span className='material-symbols-outlined'>mfg_nest_yale_lock</span>
);
